import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { TransportationEntryService } from 'src/app/service/document-control/transportation-entry.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-add-transportation-entry',
    templateUrl: './add-transportation-entry.component.html',
    styleUrls: ['./add-transportation-entry.component.scss'],
    standalone: false
})
export class AddTransportationEntryComponent implements OnInit {

  heading: string;
  errormsg: string;
  eventType: string;
  te_number
  container
  seal
  waybill
  comments: string;

  shipmentTypeList = [];
  shipmentTypeId: number;
  userId;
  constructor(public dialogRef: MatDialogRef<AddTransportationEntryComponent>, private readonly constants: Constants,
    @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly transportationEntryService: TransportationEntryService,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly exportStateService: ExportStateService) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    this.shipmentTypeList = this.dataStore.shipmentTypesDropdown;
    const userData = sessionStorage?.getItem('FGA');
    if (userData)
    {
      this.userId = JSON.parse(userData)?.user?.userPrincipalName;
    }
    if (this.eventType == 'EDIT') {  // NOSONAR
      this.te_number = this.dataStore.transportationEntryId
      this.shipmentTypeId = this.dataStore.shipmentTypeId
      this.container = this.dataStore.container
      this.seal = this.dataStore.seal
      this.waybill = this.dataStore.waybill
      this.comments = this.dataStore.comments
    }
  }
  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  public saveClick() {
    this.errormsg = ""
    if (this.isValueOk(this.te_number)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.shipmentTypeId)) {
      this.showError(this.constants.formInputError);
    } else if (this.te_number.length < 9) {
      this.showError("TE_ID must be 9 characters");
    } else {
      this.saveAPICall();
    }
  }

  keyPressNumericTE(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  saveAPICall(): void {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    if (this.eventType == "ADD") {  // NOSONAR
      const addObject = {
        te_id: this.te_number,
        container: this.container,
        seal: this.seal,
        waybill: this.waybill,
        shipment_type_id: this.shipmentTypeId,
        comments: this.comments,
      }
      this.transportationEntryService.addTransportationEntry(this.userId, addObject).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") {  // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }
        }, _error => {
          this.showError(this.constants.APIErrorMessage);

        });

    }
    else if (this.eventType == "EDIT") {  // NOSONAR
      const updateObject = {
        userId: this.userId,
        teId_teNumber: this.te_number,
        te_container: this.container,
        te_seal: this.seal,
        te_vessel: this.waybill,
        shipmentTypeId: this.shipmentTypeId,
        te_comments: this.comments,
      }
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)

      this.transportationEntryService.updateTransportationEntry(updateObject).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") {  // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }

        }, _error => {
          this.showError(this.constants.APIErrorMessage);
        });
    }

  }


  showError(message): void {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "")  // NOSONAR
      {return true;}
    return false;
  }

  ifNullSetZero(param): number {
    return Number(param ? param : 0);

  }
}
